import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { AuthenticationService } from 'src/services/authentication/authentication.service';
import { KeycloakProfile } from 'keycloak-js';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'pim-top-navigation',
  templateUrl: './top-navigation.component.html',
  styleUrls: ['./top-navigation.component.sass'],
  standalone: true,
  imports: [CommonModule]
})
export class TopNavigationComponent implements OnInit {
  @Input() showSideNav: boolean = true;
  @Output() toggleSideNav: EventEmitter<void> = new EventEmitter<void>();

  userProfile?: KeycloakProfile;
  showUserMenu = false;

  constructor(private authService: AuthenticationService) {}

  ngOnInit(): void {
    this.authService.getUserProfile().subscribe(profile => {
      this.userProfile = profile;
    });
  }

  onToggle(): void {
    this.toggleSideNav.emit();
  }

  toggleUserMenu(event: Event): void {
    event.stopPropagation();
    this.showUserMenu = !this.showUserMenu;
  }

  @HostListener('document:click')
  closeUserMenu(): void {
    this.showUserMenu = false;
  }

  logout(): void {
    this.authService.logout();
  }
}
